import styled from "styled-components";
import { VerySmall, HeadLine3 } from "../typography/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  max-width: 405px;
  min-width: 0;
  height: 245px;
  background-color: ${({theme}) => theme.grey[300]};
  border-radius: ${({theme}) => theme.radius.card};
  background-repeat: no-repeat;
  background-position: bottom right;
  position: relative;
  justify-content: flex-end;
  padding: 15px 15px 25px 20px;
  box-sizing: border-box;
  &[aria-disabled='false']:hover{
    cursor: pointer;
    > div > div:first-child {
      box-shadow: ${({theme}) => theme.shadows.card};
    }
  }
  &:focus-visible {
    outline: none;
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const VideoDescWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
`
export const DismissButton = styled.button`
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 1;
  display: grid;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  place-items: center;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }

  &:focus-visible {
    outline: none;
    border-radius: ${({theme}) => theme.radius.control};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`
export const PlayBackground = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 100%;
  background-color: ${({theme}) => theme.palette[10]};
  margin-bottom: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const VideoTitle = styled(VerySmall)`
  color:${({theme}) => theme.grey[600]};
  text-transform: uppercase;

`
export const VideoSubTitle = styled(HeadLine3)`
  color: ${({theme}) => theme.palette[850]};
  margin-top:6px;
`
